import cookies from 'browser-cookies'
import { Nullable } from '@signavio/effektif-commons'

export function changeCurrentOrganizationKey(organizationKey: string): void {
  localStorage.setItem('workflow-organization', organizationKey)
}

export type LoginInfoType = {
  token: string
  organizationKey?: string
}

export function setupSession({
  token,
  organizationKey = '',
}: LoginInfoType): void {
  localStorage.setItem('workflow-organization', organizationKey)
  localStorage.setItem('workflow-token', token)

  if (process.env.NODE_ENV !== 'production') {
    // usually the server sets this cookie and the client doesn't have
    // access to it. however, this doesn't work in a dev setup.
    // in order for the application to not seem broken we're setting this
    // cookie in development only and make sure it is gone in a production
    // build.
    cookies.set('workflow-authentication', token)
  }
}

export function tearDownSession(): void {
  localStorage.removeItem('workflow-token')
}

export function getCurrentLoginToken(): Nullable<string> {
  return localStorage.getItem('workflow-token')
}

export function getCurrentOrgKey(): Nullable<string> {
  return localStorage.getItem('workflow-organization')
}
